import { ReactNode, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { T } from "react-translator-component";
import { Box, SxProps } from "@mui/material";
import GCBackButton from "../../components/GreenCity/GCBackButton";
import Separator from "../../components/Separator";
import { useAppDispatch } from "../../redux/store";
import { reset as resetError } from "../redux/errorReducer";
import { unauthrizedError } from "../util/util";
import ErrorMessageBanner from "./ErrorMessageBanner";

interface Props {
  sx?: SxProps
  children: ReactNode;
}

export default function AdminEditPageFrame({sx, children}: Props) {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const { errorObj } = useSelector((state: any) => state.mngError)
  const [errors, setErrors] = useState<string[]>([])

  useEffect(() => {
    if (!errorObj) return

    const e = errorObj
    dispatch(resetError())
    if (typeof e === "string") {
      setErrors([e])
    } else if (e.response) {
      const message = unauthrizedError(e.response.status, dispatch)
      const responseErrors = e.response.data?.message ?? [T("api_unknown_error")]
      setErrors(message ?? responseErrors)
    } else {
      setErrors([String(e)])
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorObj])

  return (
    <>
      <Box sx={{ ...styles.container, ...sx }}>
        <GCBackButton onClick={() => navigate(-1)} />
        <Separator sx={styles.separator} color="#D3D3D3" />
        {children}
      </Box>
      <ErrorMessageBanner
        open={errors.length !== 0}
        messages={errors}
        onClose={() => setErrors([])}
      />
    </>
  );
}

const styles = {
  container: {
    paddingTop: 2,
    width: "100%",
  },
  separator: {
    marginTop: 1
  },
}
